import script from "./PageBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__